import { defineComponent as _defineComponent } from 'vue'
import type { ScoringProviderType } from './plot-recommender.store';

import RangeInput from '@/ui-components/RangeInput.vue';

import { providerScoring, usePlotRecommenderStore } from './usePlotRecommenderStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlotRecommenderRatingFilter',
  setup(__props) {

const prStore = usePlotRecommenderStore();

function changed(provider: ScoringProviderType, val: number) {
	if (val == null) return;

	prStore.filters.scorings[provider].min = Math.round(val * 10) / 10;
}

return { __sfc: true,prStore, changed, RangeInput, providerScoring }
}

})